module.exports = __webpack_public_path__ + "img/sq-10.517e250b.jpg";